<template>
	<select v-model="internalValue" :disabled="disabled" :class="disabled ? 'disabled' : ''">
		<option :value="defaultValue" v-if="defaultLabel">{{ defaultLabel }}</option>
		<option v-for="(option, key) in internalOptions" :key="key" :value="option.value">
			{{ option.label }}
		</option>
	</select>
</template>

<script>
	export default {
		name: 'simple-select-box',
		props: {
			options: {
			},
			value: {
				required: false,
				default: null
			},
			defaultLabel: {
				required: false,
				default: null
			},
			defaultValue: {
				required: false,
				default: ''
			},
			castTo: {
				required: false,
				default: 'string',
			},
			disabled: {
				required: false,
				default: false,
			}
		},
		data() {
			return {
				internalValue: this.value !== null ? this.value : this.defaultValue,
				internalOptions: [],
				runWatchers: true,
			}
		},
		mounted() {
			this.updateOptions();
			this.updateFromPropValue();
		},
		methods: {
			updateOptions() {
				let internalOptions = [];

				if (this.options instanceof Array) {
					for (let option of this.options) {
						internalOptions.push({
							value: option,
							label: option
						});
					}
				} else {
					for (let key in this.options) {
						internalOptions.push({
							value: key,
							label: this.options[key]
						});
					}
				}

				this.internalOptions = internalOptions;
			},
			updateFromPropValue() {
				if (!this.runWatchers) {
					return;
				}

				this.runWatchers = false;

				if (this.value === null) {
					this.internalValue = this.defaultValue;
				} else {
					this.internalValue = this.value;
				}

				console.log(`setting internal value from ${this.value} to ${this.internalValue}`);

				this.$nextTick(() => {
					this.runWatchers = true;
				})
			},
			updateFromInternalValue() {
				if (!this.runWatchers) {
					return;
				}

				this.runWatchers = false;

				let internalValue = this.internalValue;

				if (this.castTo === 'int') {
					internalValue = parseInt(internalValue, 10);
				}

				this.$emit('input', internalValue);

				this.$nextTick(() => {
					this.runWatchers = true;
				})
			}
		},
		watch: {
			options() {
				this.updateOptions();
			},
			value() {
				this.updateFromPropValue();
			},
			internalValue() {
				this.updateFromInternalValue();
			}
		}
	}
</script>